/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */
export const convertToUTCDate = (
  date: Date | null | undefined
): string | null => {
  if (date === undefined || date === null || isNaN(date.getTime())) return null;

  // convert to UTC time, including day shift if applicable
  return new Date(date).toISOString();
};
